<form [formGroup]="loginForm" (ngSubmit)="login()" novalidate class="sdp-login-form" *ngIf="!showMfaForm">
	<div class="sdp-form-control">
		<mat-form-field class="sdp-form-control-input-container">
			<input #emailInput matInput placeholder="{{ 'form.label.email' | translate }}" type="text" formControlName="email">
			<mat-error *ngIf="loginForm.controls['email'].hasError('required')">{{ "error.message.email" | translate }}</mat-error>
			<mat-error *ngIf="loginForm.controls['email'].hasError('invalidEmail')">{{ "error.message.email" | translate }}</mat-error>
		</mat-form-field>
	</div>
	<div class="sdp-form-control">
		<mat-form-field class="sdp-form-control-input-container">
			<input #passwordInput matInput placeholder="{{ 'form.label.password' | translate }}" type="{{ passwordType }}" formControlName="password">
			<mat-error *ngIf="loginForm.controls['password'].hasError('required')">{{ 'error.message.password' | translate }}</mat-error>
		</mat-form-field>
		<div class="sdp-password-show" [class.sdp-text-input]="passwordType==='text'">
			<sdp-icon [icon]="passwordIcon" (click)="passwordType = passwordType==='text'?'password':'text'"></sdp-icon>
		</div>
	</div>

	<div class="sdp-form-control" *ngIf="errMessage && errMessage.length > 0">
		<mat-card class="sdp-form-error-block">{{ errMessage | translate }}</mat-card>
	</div>
	<div class="sdp-form-control" *ngIf="isVerified">
		<mat-card class="sdp-form-success-block">{{ "message.account.verified" | translate }}.</mat-card>
	</div>
	<div class="sdp-form-control" *ngIf="isConfirmationResent">
		<mat-card class="sdp-form-success-block">{{ "message.account.confirmationResent" | translate }}.</mat-card>
	</div>

	<div class="sdp-form-control" *ngIf="forgot">
		<mat-card class="sdp-form-success-block">{{ "message.forgotpassword.reset" | translate }}.</mat-card>
	</div>
	<div *ngIf="recaptchaRequired">
		<re-captcha site_key="{{ recaptchaSiteKey }}" (captchaResponse)="recaptchaSuccess($event)"></re-captcha>
	</div>
	<div class="sdp-form-buttons-container">
		<button class="sdp-button-small-text" type="button" color="primary" mat-button (click)="openForgotPassword()" *ngIf="!isNotConfirmed">{{ "forgotpassword.title" | translate }}</button>
		<button mat-raised-button color="primary" (click)="isLoginSubmitted = true;" type="submit" [disabled]="!canSubmit" *ngIf="!isNotConfirmed">{{ "form.label.signIn" | translate }}</button>
		<button class="sdp-button-small-text" type="button" color="primary" mat-button (click)="resendConfirmation()" *ngIf="isNotConfirmed">{{"message.account.resendConfirmation" | translate }}</button>
	</div>
</form>

<form [formGroup]="mfaLoginForm" (ngSubmit)="login()" novalidate class="sdp-login-form" *ngIf="showMfaForm">
	<div class="sdp-form-control">
		<p>{{ "login.mfaRequired" | translate }}</p>
		<mat-form-field class="sdp-form-control-input-container">
			<input #totpInput matInput placeholder="{{ 'form.label.totp' | translate }}" type="text" formControlName="totpCode">
			<mat-error *ngIf="mfaLoginForm.controls['totpCode'].hasError('required')">{{ "error.message.totp" | translate }}</mat-error>
			<mat-error *ngIf="mfaLoginForm.controls['totpCode'].hasError('invalidTotpCode')">{{ "error.message.totp" | translate }}</mat-error>
		</mat-form-field>
	</div>
	<div class="sdp-form-control" *ngIf="errMessage && errMessage.length > 0">
		<mat-card class="sdp-form-error-block">{{ errMessage | translate }}</mat-card>
	</div>
	<div *ngIf="recaptchaRequired">
		<re-captcha site_key="{{ recaptchaSiteKey }}" (captchaResponse)="recaptchaSuccess($event)"></re-captcha>
	</div>
	<div class="sdp-form-buttons-container">
		<!--TODO add backup mfa method in phase 2 -->
		<!-- <button class="sdp-button-small-text" type="button" color="primary" mat-button>{{ "mfa.cantaccess.title" | translate }}</button> -->
		<button class="sdp-button-small-text" type="button" color="primary" (click)="cancelLogin()" mat-button>{{ "sdp.label.cancel" | translate }}</button>
		<button mat-raised-button color="primary" type="submit">{{ "form.label.signIn" | translate }}</button>
	</div>
</form>